export const infoBubble = (el) => {
    const isHoverMode = el.classList.contains('hover');

    const showTooltip = (event) => {
        if (!isHoverMode) {
            event.stopPropagation();
        }

        // Remove any existing tooltips
        document.querySelectorAll('.custom-tooltip').forEach((tooltip) => tooltip.remove());

        const tooltipContent = el.getAttribute('data-tooltip-content');
        if (!tooltipContent) return;

        // Create tooltip
        const tooltip = document.createElement('div');
        tooltip.className = 'school-profile-tooltip';
        tooltip.innerHTML = tooltipContent;
        document.body.appendChild(tooltip);

        // Position tooltip above the element and center horizontally
        const rect = el.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();
        const left = rect.left + window.scrollX + (rect.width / 2) - (tooltipRect.width / 2);
        const top = rect.top + window.scrollY - tooltipRect.height - 8; // Add a small gap

        tooltip.style.left = `${left}px`;
        tooltip.style.top = `${top}px`;

        if (isHoverMode) {
            // For hover mode, remove tooltip when mouse leaves
            const removeOnLeave = () => {
                tooltip.remove();
                el.removeEventListener('mouseleave', removeOnLeave);
            };
            el.addEventListener('mouseleave', removeOnLeave);
        } else {
            // For click mode, remove tooltip on clicking outside
            const removeTooltip = (e: MouseEvent) => {
                if (!el.contains(e.target as Node) && !tooltip.contains(e.target as Node)) {
                    tooltip.remove();
                    document.removeEventListener('click', removeTooltip);
                }
            };
            document.addEventListener('click', removeTooltip);
        }
    };

    if (isHoverMode) {
        el.addEventListener('mouseenter', showTooltip);
    } else {
        el.addEventListener('click', showTooltip);
    }
}